import React, { useEffect } from "react";
import { Pagination} from "antd";
import { connect } from "react-redux";
import { getLeaveList } from "../../../../redux/leave/leaveState";
import { DATE_FORMAT } from "variables/constants";
import LeaveCard from "./LeaveCard";
import { CalendarX } from "lucide-react";

const LeaveTable = ({ 
  recordList, 
  pagination, 
  doSearch,
  dateRange,
  filters
}) => {

  useEffect(() => {
    const filters = {
      paginate: pagination.per_page,
    };

    if (dateRange?.length === 2) {
      filters.date_from = dateRange[0].format(DATE_FORMAT);
      filters.date_to = dateRange[1].format((DATE_FORMAT));
    }

    doSearch(filters);
  }, [doSearch, pagination.per_page, dateRange]);

  return (
    <div className="max-h-[600px] overflow-y-auto pr-2">
      {recordList?.length > 0 ? (
        <LeaveCard recordList={recordList} />
      ) : (
        <div className="py-10 flex flex-col items-center justify-center text-gray-400">
          <CalendarX className="w-10 h-10 mb-3" />
          <span className="text-sm">
            No leave records found
          </span>
      </div>
      )}


      {pagination?.total > pagination?.per_page && (
        <div className="flex justify-end py-4">
          <Pagination
            current={pagination?.current_page}
            pageSize={pagination?.per_page}
            total={pagination?.total}
            showSizeChanger={false}
            onChange={(page) =>
              doSearch({
                ...filters,
                page,
                paginate: pagination?.per_page,
              })
            }
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.leave.leaveList?.items,
  pagination: state.leave.leaveList?.pagination,
  filters: state.leave.leaveList?.filters,
  requesting: state.leave.leaveList?.requesting,
  error: state.leave.leaveList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getLeaveList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveTable);
